/** Таймаут axios для quiz-вызовов (мс): чуть выше AI_QUIZ_TIMEOUT на back (240 с). */
export const QUIZ_API_TIMEOUT_MS = 250_000

export const AI_CONNECTION_ERROR_HINT =
  'Не удалось связаться с AI-сервисом (проблема сети или прокси OpenAI). Попробуйте через несколько минут или обратитесь в поддержку.'

const QUIZ_NETWORK_ABORT_HINT =
  'Запрос прерван или превышено время ожидания. Не закрывайте окно и попробуйте ещё раз.'

const QUIZ_GATEWAY_TIMEOUT_HINT =
  'Сервис AI не успел ответить. Подождите и повторите.'

function isNetworkOrAbortError(error) {
  if (error?.response) return false
  const code = String(error?.code || '')
  const msg = String(error?.message || '')
  return (
    code === 'ECONNABORTED' ||
    code === 'ERR_NETWORK' ||
    /network error/i.test(msg)
  )
}

/**
 * @param {unknown} error
 * @param {string} [fallback]
 */
export function formatQuizApiError(error, fallback = 'Не удалось выполнить запрос.') {
  const d = error?.response?.data
  const detail = typeof d?.detail === 'string' ? d.detail.trim() : ''
  const status = error?.response?.status

  if (/^connection error\.?$/i.test(detail)) {
    return AI_CONNECTION_ERROR_HINT
  }

  if (status === 502 || status === 504) {
    return QUIZ_GATEWAY_TIMEOUT_HINT
  }

  if (isNetworkOrAbortError(error)) {
    return QUIZ_NETWORK_ABORT_HINT
  }

  if (detail) return detail
  if (Array.isArray(d?.errors) && d.errors.length) return d.errors.join(' ')
  if (typeof d?.error === 'string' && d.error.trim()) return d.error.trim()
  if (typeof error?.message === 'string' && error.message.trim()) return error.message.trim()

  return fallback
}
